var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApplication(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 1.5C5.82843 1.5 6.5 2.17157 6.5 3V4C6.5 4.82843 5.82843 5.5 5 5.5H3C2.17157 5.5 1.5 4.82843 1.5 4V3C1.5 2.17157 2.17157 1.5 3 1.5H5Z",
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 7.5C5.82843 7.5 6.5 8.17157 6.5 9V12C6.5 12.8284 5.82843 13.5 5 13.5H3C2.17157 13.5 1.5 12.8284 1.5 12V9C1.5 8.17157 2.17157 7.5 3 7.5H5Z",
    stroke: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 1.5C12.8284 1.5 13.5 2.17157 13.5 3V6C13.5 6.82843 12.8284 7.5 12 7.5H10C9.17157 7.5 8.5 6.82843 8.5 6V3C8.5 2.17157 9.17157 1.5 10 1.5H12Z",
    stroke: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 9.5C12.8284 9.5 13.5 10.1716 13.5 11V12C13.5 12.8284 12.8284 13.5 12 13.5H10C9.17157 13.5 8.5 12.8284 8.5 12V11C8.5 10.1716 9.17157 9.5 10 9.5H12Z",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplication);
export default __webpack_public_path__ + "static/media/Application.cbe3e5451595564967ca86d456683e6f.svg";
export { ForwardRef as ReactComponent };